import { acceptedIndicesThrough } from '../checkLedger'
import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'

export const luckyCharmCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  if (!isAcceptedWordEntry(entry)) {
    return false
  }
  const accepted = acceptedIndicesThrough(ledger, index)
  if (accepted.length < 3) {
    return false
  }
  const a = ledger[accepted[accepted.length - 3]!]!
  const b = ledger[accepted[accepted.length - 2]!]!
  const c = ledger[accepted[accepted.length - 1]!]!
  return (
    isAcceptedWordEntry(a) &&
    isAcceptedWordEntry(b) &&
    isAcceptedWordEntry(c) &&
    a.word === b.word &&
    b.word === c.word &&
    accepted[accepted.length - 1] === index
  )
}
